{
  "farsi": true,
  "focus": false,
  "timer": false
}
